<!-- campaign form with flights to fill all data  of a campaign and return it to the campaign edit component to submit
 this form includes 3 components
1. the general form -> where we have the general data of the campaign
2. flights (sub campaigns the also include general forms ) -> where we can edit and add flights 
3. target Data form where we add the target data if applicable
-->
<script lang="ts">
  import Validators from "../../utils/validators";
  import Form from "../form/Form.svelte";
  import FormButtons from "../form/FormButtons.svelte";
  import GeneralInformation from "./GeneralInformation.svelte";
  import CollapseBox from "../form/CollapseBox.svelte";

  import { createEventDispatcher } from "svelte";
  import TargetForm from "./TargetForm.svelte";
  import InventoryForm from "./InventoryForm.svelte";
  import TrackingForm from "./TrackingForm.svelte";
  import AssetsForm from "./AssetsForm.svelte";
  import TraffickingForm from "./TraffickingForm.svelte";
  import AudienceForm from "./AudienceForm.svelte";

  const dispatch = createEventDispatcher();

  // state variables
  export let name = "";
  export let campaign_id = "";
  export let description = "";
  export let start_at = "";
  export let end_at = "";
  export let budget = 0;
  export let target_price = 0;
  export let advertiser: string[] = [];
  export let agency: string[] = [];
  export let endpoint = "";
  export let execution = null;
  export let targeting = {};
  export let isUpdate: boolean;

  let form: any;
  function onSubmit(e: any) {
    dispatch("submitForm", e.detail);
  }
  function onCancel() {
    dispatch("cancel");
  }
  const rules: any = {
    name: {
      validators: [
        Validators.required("Name is required"),
        Validators.minLength(4),
      ],
    },
    budget: {
      validators: [
        Validators.required("Budget is required"),
        //Validators.isNumber("Budget Must be a number"),
      ],
    },
    impressions: {
        validators: [Validators.isNumber(), Validators.required('Impressions is required')],
    },
    start_at: {
      validators: [Validators.required("Start Date is required")],
    },
    end_at: {
      validators: [Validators.required("End Date is required")],
    },
  };
</script>

<Form {rules} on:submit={onSubmit} bind:this={form}>
  <GeneralInformation
    name={name}
    campaign_id={campaign_id}
    description={description}
    start_at={start_at}
    end_at={end_at}
    budget={budget}
    target_price={target_price}
    advertiser={advertiser}
    agency={agency}
    endpoint={endpoint}
    execution={execution} />
  <CollapseBox title="Targeting" show={false}>
    <TargetForm data={targeting} />
  </CollapseBox>
  <CollapseBox title="Audience" show={false}>
    <AudienceForm />
  </CollapseBox>
  <CollapseBox title="Inventory" show={false}>
    <InventoryForm />
  </CollapseBox>
  <CollapseBox title="Tracking" show={false}>
    <TrackingForm />
  </CollapseBox>
  <CollapseBox title="Assets" show={false}>
    <AssetsForm />
  </CollapseBox>
  <CollapseBox title="Trafficking" show={false}>
    <TraffickingForm />
  </CollapseBox>
  <FormButtons isUpdate={isUpdate} on:cancel={onCancel} />
</Form>
